import vxMysteryHeader from '../vx-mystery-header/vx-mystery-header.vue';
import vxMysteryFooter from '../vx-mystery-footer/vx-mystery-footer.vue';
import vxMysteryOverviewMixin from './vx-mystery-overview-mixin';
import globals from '../../../components/common/globals';

export default {
  name: 'vx-mystery-overview-page',
  components: { vxMysteryHeader, vxMysteryFooter },
  mounted() {
  },
  data() {
    return {
      globals,
      submitButtonText: 'REVEAL MY MYSTERY COUPON!',
      config: {

      },
    };
  },
  mixins: [vxMysteryOverviewMixin],
};



// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-mystery-overview/vx-mystery-overview.js